export const RouteName = {
  CONFIGURATOR: 'Configurator',
  RESTORE_CONFIGURATION: 'Restore Configuration',
  SUCCESS: 'Success'
};

export default RouteName;
